import React  from "react";
import { useState } from "react";

const MovingRight = ({children, speed = "50s"}) => {
  const [pauseAnimation, setPauseAnimation] = useState(false);
  
  const handleMouseEnter = () => {
    setPauseAnimation(true);
  };

  const handleMouseLeave = () => {
    setPauseAnimation(false);
  };

  // Duplicate the children to create a seamless infinite loop
  const duplicatedChildren = React.Children.toArray(children).concat(React.Children.toArray(children));

  return (
    <>
      <div
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className="sliderContainer"
      >
        <div className="sliderWrapper w-[100%] overflow-hidden">
          <section
           className={`sliderSectionReverse ${pauseAnimation ? "stopAnimation" : ""}`}
           style={{ "--speed": speed }}
          >
           {duplicatedChildren}
          </section>
        </div>
      </div>
    </>
  );
};

export default MovingRight;
